import createReducer from '../../utils/createReducer';

const initialState = {
  experiments: {}
};

export default createReducer(initialState, {});
